import type { TriviaConfig } from "./trivia-types";

// Descriptor `defaultValue`s (apis/data-access/.../flyout-trivia.ts) only affect what the
// CMS form displays until an author touches a field — they are never persisted. This is the
// single runtime source of truth every default must match, so an un-migrated post renders
// exactly as it always has.
export const TRIVIA_DEFAULT_TIME_TO_ANSWER = 20;
export const TRIVIA_DEFAULT_PRIMARY_COLOR_BACKGROUND = "#193e7d";
export const TRIVIA_DEFAULT_PRIMARY_COLOR_TEXT = "#ffffff";
export const TRIVIA_DEFAULT_BUTTON_COLOR_BACKGROUND = "#ffffff";
export const TRIVIA_DEFAULT_BUTTON_COLOR_TEXT = "#000000";
export const TRIVIA_DEFAULT_CORRECT_COLOR = "#1f8a53";
export const TRIVIA_DEFAULT_INCORRECT_COLOR = "#c23030";
export const TRIVIA_DEFAULT_POINTS = 1;
export const TRIVIA_DEFAULT_FEEDBACK_AUTO_ADVANCE_SECONDS = 5;

export const TRIVIA_HEX_COLOR_PATTERN = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

export const TRIVIA_CONFIG_DEFAULTS: TriviaConfig = {
  questions: [],
  theme: {
    primaryBackground: TRIVIA_DEFAULT_PRIMARY_COLOR_BACKGROUND,
    primaryText: TRIVIA_DEFAULT_PRIMARY_COLOR_TEXT,
    buttonBackground: TRIVIA_DEFAULT_BUTTON_COLOR_BACKGROUND,
    buttonText: TRIVIA_DEFAULT_BUTTON_COLOR_TEXT,
    correctColor: TRIVIA_DEFAULT_CORRECT_COLOR,
    incorrectColor: TRIVIA_DEFAULT_INCORRECT_COLOR,
    accentColor: TRIVIA_DEFAULT_BUTTON_COLOR_BACKGROUND,
    panelColor: TRIVIA_DEFAULT_PRIMARY_COLOR_BACKGROUND,
    secondaryTextColor: TRIVIA_DEFAULT_PRIMARY_COLOR_TEXT,
    cornerStyle: "rounded",
    density: "comfortable",
    overlayOpacity: 0,
  },
  welcome: {
    enabled: false,
    startButtonLabel: "Start",
  },
  timer: {
    enabled: true,
    seconds: TRIVIA_DEFAULT_TIME_TO_ANSWER,
  },
  feedback: {
    enabled: true,
    autoAdvance: true,
    autoAdvanceSeconds: TRIVIA_DEFAULT_FEEDBACK_AUTO_ADVANCE_SECONDS,
    correctMessage: "Correct!",
    incorrectMessage: "Not quite.",
    nextLabel: "Next Question",
    showDistribution: true,
    simulateDistribution: false,
  },
  results: {
    heading: "Your Score",
    scoreFormat: "fraction",
    completeLabel: "Complete",
    showChart: true,
    showQrCode: true,
  },
  progress: {
    visible: true,
  },
  randomizeQuestions: false,
  randomizeAnswers: false,
  help: {
    enabled: true,
    fiftyFifty: true,
  },
};
